import React, { useState, useEffect } from 'react';

import Link from 'next/link';

import Button from '@components/common/Button/Button';
import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import IconCheckmark from '@components/common/IconCheckmark/IconCheckmark';
import ConfirmModal from '@components/common/Modals/ConfirmModal/ConfirmModal';
import NotificationBloc from '@components/common/NotificationBloc/NotificationBloc';
import Text from '@components/common/Text/Text';
import LoginForm from '@components/lpc/Authentication/LeftSide/Login/LoginForm/LoginForm';
import SocialConnect from '@components/lpc/Authentication/LeftSide/SocialConnect/SocialConnect';
import { loginErrorType } from '@propTypes/errorTypes';
import contact from '@services/http/Contact';
import { getRoute, ROUTE } from '@services/http/Route';

import css from './Login.module.scss';

const Login = () => {
    const { t } = useTranslateLpc(['lpc-authentication', 'common']);
    const [error, setError] = useState<loginErrorType>({ smsLimitSmsExceeded: false, credentialsError: false });
    const [isAccountBlockedModalVisible, setIsAccountBlockedModalVisible] = useState<boolean>(false);

    useEffect(() => {
        error.smsLimitSmsExceeded && setIsAccountBlockedModalVisible(true);
    }, [error]);

    const onContactService = () => {
        const subject = t('blocked-modal.contact-subject');
        // @ts-ignore
        return (document.location = 'mailto:' + contact.CUSTOMER_SERVICE + '?subject=' + subject);
    };

    return (
        <div className={css.login}>
            <section className={css.login__form}>
                <h3>{t('login.title')}</h3>

                <SocialConnect />

                <p className={css.divider}>
                    <span>{t('login.or')}</span>
                </p>

                {error && error.credentialsError && (
                    <NotificationBloc
                        customClass={css.notification}
                        onResetVisibility={(value) => setError(value)}
                        variant={'warning'}
                        message={t('errors.AUTH_FAILED')}
                    />
                )}

                <ConfirmModal
                    onHide={() => setIsAccountBlockedModalVisible(false)}
                    onConfirm={() => onContactService()}
                    isLoading={false}
                    title={t('blocked-modal.title')}
                    text={t('blocked-modal.text', {
                        phone: contact.customerService.phone,
                        email: contact.customerService.email,
                    })}
                    confirmLabel={t('blocked-modal.cta')}
                    isVisible={isAccountBlockedModalVisible}
                    iconComponent={<IconCheckmark variant={'warning'} />}
                    customIcon={css.modal}
                />

                <LoginForm setError={setError} />
                <section className={css.create_account}>
                    <Text variant={'caption_01'} color="txt-primary">
                        {t('login.create-account-text')}
                    </Text>
                    <Link href={getRoute(ROUTE.LPC.AUTH.SIGN_UP)}>
                        <Button customClass={css.create_account__cta} variant="tertiary">
                            {t('login.create-account-button')}
                        </Button>
                    </Link>
                </section>
            </section>
        </div>
    );
};

export default Login;
